import {
  BookIcon, PenIcon, WalletIcon, MicIcon, TargetIcon, KeyIcon, BellIcon,
  SearchIcon, CalendarIcon, SparkleIcon, SettingsIcon, LockIcon, RefreshIcon,
} from "./Icons.jsx";

export const SECTIONS = [
  { id: "all", label: "All & Search", Icon: SearchIcon, group: "browse" },
  { id: "diary", label: "Diary", Icon: BookIcon, group: "browse" },
  { id: "journal", label: "Journal", Icon: PenIcon, group: "browse" },
  { id: "voice", label: "Voice Notes", Icon: MicIcon, group: "browse" },
  { id: "password", label: "Passwords", Icon: KeyIcon, group: "browse" },
  { id: "calendar", label: "Calendar", Icon: CalendarIcon, group: "plan" },
  { id: "alerts", label: "Alerts", Icon: BellIcon, group: "plan" },
  { id: "goals", label: "Goals", Icon: TargetIcon, group: "plan" },
  { id: "financials", label: "Financials", Icon: WalletIcon, group: "plan" },
  { id: "askai", label: "Ask AI", Icon: SparkleIcon, group: "assist" },
];

const GROUPS = [
  { id: "browse", label: "Vault" },
  { id: "plan", label: "Plan & track" },
  { id: "assist", label: "Assist" },
];

const SYNC_TEXT = {
  idle: "Not synced yet",
  syncing: "Syncing…",
  ok: "Synced",
  offline: "Offline — saved locally",
  error: "Sync problem",
};

export function Sidebar({ section, onSection, counts, sync, open, onOpenSettings, onLock, onSync }) {
  return (
    <aside className={`sidebar ${open ? "open" : ""}`}>
      <div className="sidebar-brand">
        <div className="brand-mark sm">A</div>
        <span>AIDIA</span>
      </div>

      <nav>
        {GROUPS.map((group) => (
          <div key={group.id}>
            <div className="nav-group-label">{group.label}</div>
            {SECTIONS.filter((s) => s.group === group.id).map(({ id, label, Icon }) => (
              <button
                key={id}
                className={`nav-item ${section === id ? "active" : ""}`}
                onClick={() => onSection(id)}
                aria-current={section === id ? "page" : undefined}
              >
                <span className="nav-ico"><Icon size={17} /></span>
                <span className="truncate">{label}</span>
                {counts[id] > 0 && (
                  <span className={id === "alerts" ? "badge danger" : "count"}>{counts[id]}</span>
                )}
              </button>
            ))}
          </div>
        ))}
      </nav>

      <div className="sidebar-foot">
        <button
          className="sync-pill"
          onClick={onSync}
          title={sync.error || SYNC_TEXT[sync.status]}
          style={{ cursor: "pointer", width: "100%" }}
        >
          <span className={`sync-dot ${sync.status}`} />
          <span className="truncate grow" style={{ textAlign: "left" }}>
            {SYNC_TEXT[sync.status] || "Sync"}
          </span>
          {sync.pending > 0 && <span className="tiny muted">{sync.pending}</span>}
          <RefreshIcon size={13} />
        </button>

        <div className="row" style={{ gap: "var(--s-2)" }}>
          <button className="btn btn-ghost grow" onClick={onOpenSettings}>
            <SettingsIcon size={15} /> Settings
          </button>
          <button className="icon-btn" onClick={onLock} title="Lock vault" aria-label="Lock vault">
            <LockIcon size={16} />
          </button>
        </div>
      </div>
    </aside>
  );
}
